<div #fixedHeaderMenu *ngIf="url1" class="fixed-header-menu">
    <app-header></app-header>
    <app-nav-menu></app-nav-menu>
</div>

<mat-drawer-container class="mat-typography" [ngClass]="url1 ? '' : 'mat-drawer-container-nooauth'" autosize>
    <main [style.margin-top.px]="headerMenuHeight" [ngClass]="url1 ? 'main' : 'html-newnoauth'">
        <div>
            <router-outlet></router-outlet>
        </div>
    </main>
</mat-drawer-container>
<footer class="site-footer">
    <div class="footer-inner">
        <div class="footer-left">
            <nav class="footer-links" aria-label="Footer navigation">
                <a href="https://areafacturasclubmpa.movistarproseguralarmas.es/privacy_policy" target="_blank">Política de privacidad</a>
                <span class="sep">|</span>
                <a href="https://areafacturasclubmpa.movistarproseguralarmas.es/legal_base" target="_blank">Aviso legal</a>
                <span class="sep">|</span>
                <a href="https://areafacturasclubmpa.movistarproseguralarmas.es/cookies" target="_blank">Cookies</a>
            </nav>
        </div>
        <div class="footer-right">
            <small>Copyright Movistar Prosegur Alarmas</small>
        </div>
    </div>
</footer>
